import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import SharedWithMe from "@/pages/SharedWithMe";
import EmergencyAccess from "@/pages/EmergencyAccess";
import Settings from "@/pages/Settings";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Contact from "@/pages/Contact";
import ForcePasswordChange from "@/components/ForcePasswordChange";
import { ThemeProvider } from "next-themes";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[color:var(--vault-text-tertiary)]">
        Unlocking…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem storageKey="ezguard-theme" disableTransitionOnChange>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="vault" element={<Dashboard />} />
              <Route path="shared" element={<SharedWithMe />} />
              <Route path="emergency" element={<EmergencyAccess />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
